import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { RolesEnum } from '../../../models/enums/roles.enum';
import { MarkdownComponentService } from '../../../services/markdown-component.service';
import { UserSessionService } from '../../../services/user-session.service';

@Component({
    selector: 'sl-markdown',
    templateUrl: './markdown.component.html',
    styleUrls: ['./markdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MarkdownComponent implements OnInit {
    @Input() id: string;

    text: string;
    isSaving = false;
    isLoading = true;
    isEditing = false;
    canEdit = false;

    private readonly userSessionService = inject(UserSessionService);
    private readonly markdownComponentService = inject(MarkdownComponentService);

    // removal of markdown-component is happening in dashboardservice
    // when removing the widget

    ngOnInit(): void {
        this.canEdit = this.userSessionService.roleId >= RolesEnum.Operator;

        this.markdownComponentService
            .get(this.id)
            .pipe(
                catchError(() => {
                    this.isLoading = false;
                    return of({ value: '' });
                })
            )
            .subscribe(content => {
                this.text = atob(content.value);
                this.isLoading = false;
            });
    }

    save(): void {
        this.isSaving = true;

        this.markdownComponentService.save(this.id, this.text).subscribe(() => {
            this.isSaving = false;
            this.isEditing = false;
        });
    }
}
